import { AccountUserApiV2 } from '../../../../../../lib/api/account/user/AccountUserApiV2';
import { UserGradeHistoriesRequestOptionType, UserGradeHistoriesResponseType } from '../types';

export type IUserGradeHistoryRespository = {
  getUserGradeHistories: (
    userId: number,
    options: UserGradeHistoriesRequestOptionType,
  ) => Promise<UserGradeHistoriesResponseType>;
};

export const UserGradeHistoryRespository: IUserGradeHistoryRespository = {
  getUserGradeHistories: (
    userId: number,
    options: UserGradeHistoriesRequestOptionType,
  ): Promise<UserGradeHistoriesResponseType> => {
    return AccountUserApiV2.getUserGradeHistories(userId, options);
  },
};
